import z from "zod";

const slackErrorTypeValues = ["UNKNOWN", "STALE_WEBHOOK"] as const;
const slackErrorTypeSchema = z.enum(slackErrorTypeValues);
const SlackErrorType = slackErrorTypeSchema.enum;
type SlackErrorType = z.infer<typeof slackErrorTypeSchema>;

export type SlackErrors =
  | { errorType: typeof SlackErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof SlackErrorType.STALE_WEBHOOK; data: { channelUrl: string } };

export const slackErrorDetails: Record<SlackErrorType, { sentryDescription: string }> = {
  UNKNOWN: { sentryDescription: "Unknown Slack Error" },
  STALE_WEBHOOK: {
    sentryDescription: "Slack webhook returned 404 — the webhook URL has been deleted or invalidated",
  },
};
